import { render, staticRenderFns } from "./TheSourceFormItem.vue?vue&type=template&id=16a9e126&scoped=true&"
import script from "./TheSourceFormItem.vue?vue&type=script&lang=js&"
export * from "./TheSourceFormItem.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceFormItem.vue?vue&type=style&index=0&id=16a9e126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a9e126",
  null
  
)

export default component.exports